import { always, F, T } from 'ramda';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { pickPayload } from 'app/reducers/helpers';
import {
  couponReset,
  couponSelected,
  couponFlowSelected,
  couponLoadingStarted,
  couponValidated,
} from 'app/features/couponCampaign/actions';
import { landing } from 'app/features/couponCampaign/landing/reducers';

const code = handleActions(
  { [couponSelected]: pickPayload, [couponReset]: always('') },
  '',
);

const isValid = handleActions(
  { [couponValidated]: pickPayload, [couponReset]: F },
  false,
);

const isLoading = handleActions(
  { [couponLoadingStarted]: T, [couponValidated]: F },
  false,
);

const flowPath = handleActions(
  { [couponFlowSelected]: pickPayload, [couponReset]: always('') },
  '',
);

const coupon = persistReducer(
  { storage, key: 'coupon', whitelist: ['code', 'flowPath'] },
  combineReducers({ code, isValid, isLoading, flowPath, landing }),
);

export { coupon, code, isValid, isLoading };

export default coupon;
